<template>
  <CCardBody class="dataTable__body tableBalance__body p-0" v-if="viewMode.hiddenTable">
    <h4 class="font-weight-normal mb-2">{{ $t(`backoffice.manage.balance.tables.table-balance`) }}</h4>
    <hr v-if="viewMode.haslineNameTable" />
    <CDataTable
      v-if="currentBalances.length"
      :fields="itemsFields"
      :items="currentBalances"
      :table-filter="{ external: true, lazy: true }"
      items-per-page-select
      :responsive="false"
      :loading="false"
      hover
    >
      <template #country="{ item }">
        <td>
          <span>
            <img :src="handleCountry(item).flag" width="30" height="auto" />
            <span class="ml-2">
              {{ handleCountry(item).label }}
            </span>
          </span>
        </td>
      </template>
      <template #balance="{ item }">
        <td class="position-relative">
          <span>
            {{ numberWithCommas(item.balance) }}
          </span>
          <TableAlert :payload="item" />
        </td>
      </template>
      <template #value="{ item, index }">
        <td class="position-relative">
          <AddReduceBalance
            :item="item"
            :index="index"
            :key="Math.floor(Math.random() * 100)"
            @toggle-inputValueAll="closeAllModalInputValue"
            @toggle-inputValue="toggleInputValue"
            @incrementOrDecrementBalance="incrementOrDecrementBalance"
            @close-confirmation-inputValuel="closeAllModalInputValue"
          />
        </td>
      </template>
      <template #delete="{ item, index }">
        <td class="position-relative text-center">
          <CButton
            :data-cy="'deleteLinecurrentBalancese' + index"
            color="white"
            aria-label="delete"
            title="delete"
            class="tableBalance__btn"
            @click.stop="toggleDelete(item)"
          >
            <CIcon name="trash" class="mx-1" size="custom-size" :height="12" viewBox="0 0 32 32" />
          </CButton>

          <transition name="fade" v-if="item._modalDelete">
            <div class="dataTable__popUp popUp dataTable__popUp--right popUp" @click.stop.stop>
              <div class="popUp__body shadow-sm">
                <ConfirmationDelete
                  :title="''"
                  :description="$t('backOffice.manage.balace.tables.table-one-shot.text-delete')"
                  @confirm="removeBalance(item)"
                  @cancel="toggleDelete(item)"
                />
              </div>
            </div>
          </transition>
        </td>
      </template>
    </CDataTable>
    <SelectCountry
      data-cy="selectCountryTablerecurrentAddOns"
      :removeCountries="hasContriesInList"
      :countriesList="balanceSmsOrigin"
      @add-country="addLine"
    />
  </CCardBody>
</template>

<script>
import ConfirmationDelete from '@/components/ConfirmationDelete'
import { actionsRecurring } from '../../mixins/ActionsTransactionsTable'
import { nameCountries } from '@/utils/countriesUtils.js'

const fields = [
  { key: 'country', label: 'Country', _classes: 'hidden' },
  { key: 'balance', label: 'Current Balance', _classes: 'hidden' },
  { key: 'value', label: 'ADD/REDUCE', _classes: 'hidden' },
  { key: 'delete', label: '', _classes: 'hidden text-center', _style: 'width:80px' },
]

export default {
  name: 'TableBalanceCurrentSMS',
  components: {
    ConfirmationDelete,
    SelectCountry: () => import('./SelectCountry.vue'),
    AddReduceBalance: () => import('./AddReduceBalance.vue'),
    TableAlert: () => import('./TableAlert.vue'),
  },
  mixins: [actionsRecurring],
  props: {
    currentBalances: {
      type: Array,
      default: () => {},
    },

    channel: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      itemsTable: [],
      itemsFields: [],
    }
  },

  mounted() {
    this.itemsTable = JSON.parse(JSON.stringify(this.currentBalances))
    // para tabela de currentBalances de email, n é para mostrar a coluna de país
    this.itemsFields = this.channel == 'sms' ? fields : fields.filter((item) => item.key !== 'country')
  },

  computed: {
    show() {
      return !(this.channel == 'email' && this.currentBalances.length)
    },

    hasContriesInList() {
      return this.currentBalances.map((item) => item.countryId)
    },

    balanceSmsOrigin() {
      return this.$store.getters['backOffice/balanceSmsOrigin']?.map((i) => i.countryId) || []
    },

    viewMode() {
      // // se state off e não há indices em currentBalances
      // if (this.currentBalances.length == 0) {
      //   return { hiddenTable: false }
      // }

      // se state on e não há indices em currentBalances
      if (this.currentBalances.length == 0) {
        return { hiddenTable: true, haslineNameTable: true }
      }

      // // se state on e há indices em currentBalances
      // if (this.currentBalances.length) {
      //   return { hiddenTable: true }
      // }

      return { hiddenTable: true }
    },
  },

  methods: {
    addLine(newData) {
      let data = {
        countryId: newData.value,
        balance: 0,
        _channel: this.channel,
        _typeTable: 'currentBalances',
        _tempId: Math.floor(Math.random() * 1000000),
        _currentBalanceTemp: 1,
        _modalChangeValue: false,
        _modalDelete: false,
        _message: {
          dismissCountDown: false,
          text: '',
          status: '',
        },
      }

      this.$store.commit('backOffice/ADD_LINE', { data, table: 'currentBalances' })
    },

    handleCountry(data) {
      const item = nameCountries(this).filter((item) => item.value.toUpperCase() == data.countryId.toUpperCase())
      if (item[0]) {
        return { ...item[0] }
      }
      return ''
    },
  },
}
</script>
